// Reusable US Letter (landscape) UNFI packing list (DOSS PO-v4 design); mapped identity.
// Generated by scripts/wms/generate.ts for PHP-425. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomUnfiPackingListFileDataSchema = yup.object().shape({
  customerDisplayName: yup.string().nullable().optional(),
  customerBrandSubtitle: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  pickupDate: yup.string().nullable().optional(),
  vendorName: yup.string().nullable().optional(),
  vendorAddress: yup.string().nullable().optional(),
  destinationName: yup.string().nullable().optional(),
  destinationAddress: yup.string().nullable().optional(),
  carrier: yup.string().nullable().optional(),
  loadNumber: yup.string().nullable().optional(),
  sealNumber: yup.string().nullable().optional(),
  temperatureControlled: yup.string().nullable().optional(),
  cartonPackageCount: yup.string().nullable().optional(),
  palletCount: yup.string().nullable().optional(),
  totalNetWeight: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        upc: yup.string().nullable().optional(),
        unfiSku: yup.string().nullable().optional(),
        itemDescription: yup.string().nullable().optional(),
        qtyShipped: yup.string().nullable().optional(),
        netWeight: yup.string().nullable().optional(),
        useByDate: yup.string().nullable().optional(),
        countryOfOrigin: yup.string().nullable().optional(),
      }),
    )
    .required(),
})

export type BiomUnfiPackingListFileData = yup.InferType<typeof biomUnfiPackingListFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<BiomUnfiPackingListFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomUnfiPackingListFileMappings: RequiredFileData = {
  customerDisplayName: '9fd5944d-f8b3-4397-806b-a93de6bd1f6c',
  customerBrandSubtitle: '8d20fb98-7f19-416f-b19a-45689be81d08',
  poNumber: '8164297c-593c-48ff-8ba7-a1c0ed9a7935',
  pickupDate: '434bc04c-adc5-46e0-a7d0-d474deb71464',
  vendorName: '00896e77-a214-4d93-a6ac-70eef14f204c',
  vendorAddress: 'c313fb78-5a5b-428c-902c-f7a9bb90d64c',
  destinationName: '64e79d89-04d9-428f-bde3-c3e0c8ded5ef',
  destinationAddress: 'c100ce84-5709-46a6-a2a8-fdb5326767c4',
  carrier: '7a6dd034-3486-43b2-8e2a-b6f11e87a6ea',
  loadNumber: '9e5d791b-3f90-4ca8-bf07-a98f6a98e4a1',
  sealNumber: '8fec5a0d-ca12-477b-aeee-cf2e48cc12c7',
  temperatureControlled: 'fcb8d079-7f8f-4098-a7ee-9594e44b57b9',
  cartonPackageCount: '56306393-24bc-4934-8d02-77facf2e3a7f',
  palletCount: 'fb81fd9a-e97b-4814-b40f-a60af0e01b30',
  totalNetWeight: '1a4ca10f-969a-425a-aa02-e9ebc5dc3c81',
  items: [
    {
      upc: '5576f81e-0a13-4b50-83e0-ef20153783e9',
      unfiSku: 'd33eb8b7-267e-4001-8c4b-30505f50bf21',
      itemDescription: 'ea5c5319-5188-40e1-a194-63eef7ae62d1',
      qtyShipped: '53334f1f-2578-4c2a-a421-0fe6d60e50d8',
      netWeight: '336e516b-5523-4713-ab9e-33a888f3ff11',
      useByDate: 'a5f6cf3d-9c04-417b-b8fd-6bbc0615b2bf',
      countryOfOrigin: '419d1248-d68a-4b0d-906b-5c6af654ff52',
    },
  ],
}
